/**
 * @generated SignedSource<<ec102453c7abe7a17415ac6b70af2439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainParentIndicator_todo$data = {
  readonly parent: {
    readonly id: string;
    readonly subTodos: ReadonlyArray<{
      readonly status: TodoStatus;
    }> | null;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoCircleStatusWithResponse_todo">;
  } | null;
  readonly " $fragmentType": "TodoEditNewMainParentIndicator_todo";
};
export type TodoEditNewMainParentIndicator_todo$key = {
  readonly " $data"?: TodoEditNewMainParentIndicator_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainParentIndicator_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainParentIndicator_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Todo",
          "kind": "LinkedField",
          "name": "subTodos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoCircleStatusWithResponse_todo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "957fa997d384cca9663e14126ab0cf81";

export default node;
